import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

const Attached = ({
  color = 'icon.primary',
  fill = 'transparent',
  strokeWidth = '1',
  ...props
}) => (
  <IconBase viewBox='0 0 11 11' {...props}>
    <Path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.41267 6.07628L8.58423 4.90387C9.51459 3.94934 9.50509 2.42362
         8.56291 1.48076C7.62073 0.5379 6.09611 0.52839 5.14227 1.45942L3.9707 2.63183'
      stroke={color}
      fill={fill}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M6.44788 3.59656L3.5957 6.45079'
      stroke={color}
      fill={fill}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M2.62682 3.97888L1.45526 5.15129C0.524901 6.10583 0.534403 7.63155
         1.47658 8.57441C2.41876 9.51727 3.94338 9.52677 4.89723 8.59574L6.06879 7.42333'
      stroke={color}
      fill={fill}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </IconBase>
)

Attached.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.string,
}

export default Attached
